import React from "react";
import classes from "./Testimonials.module.scss";
import CustomImage from "../../CustomImage";
import useEmblaOverflow from "../../../hooks/useEmblaOverflow";
import LazyMedia from "../../LazyMedia";
import useIsMobile from "../../../hooks/useIsMobile";

const Testimonials = ({ countryData }: { countryData: any }) => {
  const isMobile = useIsMobile(1200);
  const testimonialsData = countryData?.videoTestimonial ?? [];

  const { emblaRef, hasOverflow, canScrollPrev, canScrollNext, scrollPrev, scrollNext } = useEmblaOverflow();

  const renderCards = () =>
    testimonialsData?.testimonialVideos?.map((item: any) => (
      <div className={classes["tm-slide"]} key={item.id}>
        <div className={classes["tm-card"]}>
          <div className={classes["tm-quote-icon"]}>
            <CustomImage src="/icons/quote_icon.svg" height={28} width={42} alt="quote" />
          </div>

          <div className={classes["tm-video-area"]}>
            <LazyMedia
              iframeClassName={classes["tm-video"]}
              src={item.videoLink}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
          </div>
          <div className={classes["tm-text-area"]}>
            {item?.name && <h3 className={classes["tm-name"]}>{item?.name}</h3>}
            {item?.university && <p className={classes["tm-description"]}>{item?.university}</p>}
          </div>
        </div>
      </div>
    ));

  return (
    <section className={classes["tm-section"]}>
      <div className={classes["tm-container"]}>
        <h2 className={classes["tm-heading"]}>{testimonialsData?.title ?? ""}</h2>
        <div className={classes["tm-subtext"]} dangerouslySetInnerHTML={{ __html: testimonialsData?.subTitle ?? "" }}></div>

        <div className={classes["tm-carousel-wrap"]}>
          <div className={classes["tm-viewport"]} ref={emblaRef}>
            <div style={!isMobile && testimonialsData?.testimonialVideos?.length < 4 ? { justifyContent: "center" } : {}} className={classes["tm-slider"]}>
              {renderCards()}
            </div>
          </div>
          {hasOverflow && (
            <div className={classes["tm-arrows-below"]}>
              <button
                className={`${classes["tm-arrow"]}${canScrollPrev ? "" : ` ${classes["tm-arrow-disabled"]}`}`}
                onClick={scrollPrev}
                disabled={!canScrollPrev}
                aria-label="Previous"
              >
                <CustomImage src="/new-images/left-arrow.svg" height={17} width={10} alt="left-arrow" />
              </button>
              <button
                className={`${classes["tm-arrow"]}${canScrollNext ? "" : ` ${classes["tm-arrow-disabled"]}`}`}
                onClick={scrollNext}
                disabled={!canScrollNext}
                aria-label="Next"
              >
                <CustomImage src="/new-images/right-arrow.svg" height={17} width={10} alt="right-arrow" />
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
